export const POST_BANKS = 'POST_BANKS';
export const LIST_BANKS = 'LIST_BANKS';
